import request from '../request.js';

/**
 * Сделать обычный заказ коллективным
 * @param {Number} orderId
 * @param {Number} eventId
 * @param {Number} serviceId
 * @return {Promise}
 */
export const makeOrderBulk = (orderId, eventId, serviceId) => {
  return request({
    url: '/bulk-buy-teacher/do-bulk',
    type: 'GET',
    needOverlay: false,
    data: {
      orderId,
      eventId,
      serviceId,
    },
  });
};

/**
 * Получить список билетов учителя
 * @return {Promise}
 */
export const getTeacherTickets = () => {
  return request({
    url: '/bulk-buy-teacher/tickets',
    type: 'GET',
    needOverlay: true,
  });
};

/**
 * Получить ссылку для учеников
 * @param {Number} orderId
 * @return {Promise}
 */
export const getStudentLink = (orderId) => {
  return request({
    url: '/bulk-buy-teacher/student-link',
    type: 'GET',
    needOverlay: false,
    data: {
      orderId,
    },
  });
};

/**
 * Пометить и добавить билет Сопровождающего в корзину
 * @param {Number} orderId
 * @param {String} uid
 * @return {Promise}
 */
export const markTicketAccompaying = (orderId, uid, serviceId) => {
  return request({
    url: '/bulk-buy-teacher/mark-accompanying',
    type: 'POST',
    needOverlay: false,
    data: {
      orderId,
      uid,
			serviceId,
    },
  });
};

/**
 * Удалить место из заказа Коллективной покупки
 * @param {String} uid
 * @return {Promise}
 */
export const removeTicketFromOrder = (uid, serviceId, orderId) => {
  return request({
    url: '/bulk-buy-teacher/remove-ticket',
    type: 'POST',
    needOverlay: true,
    data: {
      uid,
      serviceId,
      orderId,
    },
  });
};
